// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__Bfb1r","loading_test":"Loading_loading_test__WW+IX","box":"Loading_box__dpf5k","load":"Loading_load__cjnjL"};